// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import constants from '../Constants';
import { updateProfileApi } from './Api';
import { SAVE_USERPROFILE, sessionLogout } from './actions'
export const UPDATE_USER_LOCATION = 'UPDATE_USER_LOCATION';
export const UPDATE_SIGNUP_USER_LOCATION = 'UPDATE_SIGNUP_USER_LOCATION';
// status


export function updateProfile(profileData) {
    return function (dispatch) {
        updateProfileApi(localStorage.userId, profileData).then(response => {
            // console.log('updateProfileApi::', response)
            if(response && response.data){
                dispatch({ type: SAVE_USERPROFILE, result: response.data });
                if(response.data.passwordUpdated){
                    alert(constants.MESSAGES.SUCCESS.USER_PASSWORD_UPDATED);
                    dispatch(sessionLogout());
                }
                else
                    alert(constants.MESSAGES.SUCCESS.USER_PROFILE_UPDATED);
            }
            else if (response && response.error){
                if(typeof response.error === "string"){
                    alert(response.error);
                }
                else {
                    alert(constants.MESSAGES.ERROR.GENERAL_ERROR);
                }
            }
        }).catch(error => {
            // console.log('error::', error)
        });
    };
}

export function updateUserLocation(obj) {
    return {
        type: UPDATE_USER_LOCATION,
        result: obj,
    };
}

export function updateSignUpUserLocation(obj) {
    return {
        type: UPDATE_SIGNUP_USER_LOCATION,
        result: obj,
    };
}



// WEBPACK FOOTER //
// ./src/js/actions/settings.js